
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import {
    isPMDB, isNLW, isANT, isFcpworks, isStandardGroup,
    isERTU, isMotorvision, isFrancetv, isSynology, isVifogra, isPorscheArchiv
}
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import SortHelper from 'Flow2/components/Article/Helpers/SortHelper';

export const MEDIA_FIELDS = [
    {
        media: "pictures,video,web",
        changedMedia: "sourcevideo,web",
    }
]

/* TABLE SORTING BEGIN */
const getMfDataConfig = ({ field, tempConfig }) => {
    if (tempConfig && tempConfig.length) {
        let masterdata = tempConfig[0].data;
        if (masterdata) {
            let found = masterdata.find(item => item.name === field);
            if (found && found.data) return found.data;
        }
    }
    return;
}

export const changeStrAndSortNrOfObj = ({ convertedData, field, sorted }) => {
    if (convertedData && field) {
        let newData = convertedData.map(item => {
            if (item[field]) item[`customaddfield${field}`] = parseInt(item[field]);
            return item;
        });
        if (newData) {
            let sortParams = sorted ? { prop: [`customaddfield${field}`] } : { prop: [`customaddfield${field}`], desc: true };
            newData = DataUtil.sortByProperty(newData, sortParams);
            return newData.map(item => {
                if (item[`customaddfield${field}`]) delete item[`customaddfield${field}`];
                return item;
            });
        }
    }
    return;
}

const setSortPropsData = ({ maindata, field, fromMulti, tempConfig }) => {
    if (!maindata) return [];
    let sortField = getMfDataConfig({ field, tempConfig });
    if (sortField) {
        let sortFieldObj = {};
        sortField.forEach(item => {
            let id = item.ID ? item.ID : item.id;
            if (id) sortFieldObj[id] = item;
        });
        return maindata.map(item => {
            let order = 0;
            let found = false;
            if (item[fromMulti]) {
                let newFrom = item[fromMulti].split(',');
                if (item.sourcefile) {
                    found = true;
                    order += 1;
                }
                if (newFrom.length) {
                    newFrom.forEach(el => {
                        if (sortFieldObj[el]) {
                            found = true;
                            if (sortFieldObj[el].customorder) {
                                order += sortFieldObj[el].customorder;
                            }
                            else order += 999;
                        }
                    })
                }
                if (found) return { ...item, [`customspecial${field}order`]: order };
            }
            return { ...item, [`customspecial${field}order`]: 999 };
        });
    }
    return maindata;
}

const sortSubContentFromMulti = ({ maindata, mainfield, secondfield, fromMulti, tempConfig }) => {
    let newSorted = setSortPropsData({ maindata, field: secondfield, fromMulti, tempConfig });
    let curMainSortField = null;
    let tmpAcc = [];
    let len = maindata.length;
    newSorted = newSorted.reduce((acc, cur) => {
        len--;
        if (!curMainSortField) curMainSortField = cur[`customspecialsort${mainfield}`];
        if (curMainSortField !== cur[`customspecialsort${mainfield}`]) {
            curMainSortField = cur[`customspecialsort${mainfield}`];
            if (tmpAcc.length) tmpAcc = DataUtil.sortByProperty(tmpAcc, { prop: `customspecial${secondfield}order` });
            if (len === 0) acc = [...acc, ...tmpAcc, cur];
            else acc = [...acc, ...tmpAcc];
            tmpAcc = [];
            tmpAcc.push(cur);
        } else {
            tmpAcc.push(cur);
            if (len === 0) {
                if (tmpAcc.length) tmpAcc = DataUtil.sortByProperty(tmpAcc, { prop: `customspecial${secondfield}order` });
                acc = [...acc, ...tmpAcc];
            }
            else acc = [...acc];
        }

        return acc;
    }, []);

    return newSorted.map(item => {
        delete (item[`customspecialsort${mainfield}`]);
        delete (item[[`customspecial${secondfield}order`]]);
        return item;
    });
}

const sortMainContentFromMulti = ({ convertedData, appLang, mainfield, sorted, fromMulti, tempConfig }) => {
    let sortField = getMfDataConfig({ field: mainfield, tempConfig });
    let sortParams = sorted ? "" : "-";
    sortParams = sortParams + `customspecialsort${mainfield}`;

    if (sortField) {
        let sortFieldObj = {};
        sortField.forEach(item => sortFieldObj[`${item.ID}`] = item);
        if (convertedData) {
            convertedData = convertedData.map(item => {
                if (item[fromMulti]) {
                    let newFrom = item[fromMulti].split(',');
                    let exists = newFrom.find(el => sortFieldObj[el]);
                    let found = sortField.find(item => item.ID === exists);
                    let mainLg = DataUtil.getLanguage(appLang);
                    if (found) return { ...item, [`customspecialsort${mainfield}`]: found[mainLg] }
                }
                return { ...item, [`customspecialsort${mainfield}`]: '' }
            });

            return convertedData.sort(DataUtil.dynamicSortAndIgnoreCase(sortParams));
        }

    }
    return convertedData;
}

export const makeMultipleSort = ({ convertedData, mainfield, secondfield, sorted, appLang, fromMulti, tempConfig }) => {
    if (convertedData) {
        let sortedMainContent = sortMainContentFromMulti({ convertedData, appLang, mainfield, sorted, fromMulti, tempConfig });
        let sortedData = sortSubContentFromMulti({ maindata: sortedMainContent, mainfield, secondfield, fromMulti, tempConfig });
        return sortedData;
    }
    return [];
}

export const getSortedData = ({ data, name, sorted, appLang, tempConfig }) => {
    let sortParams;
    let sortedData = [];
    try {
        if (data) {
            let convertedData = DataUtil.convertObjectKeyData(data);
            if (name === "language")
                return makeMultipleSort({ convertedData, mainfield: "language", secondfield: "purpose", sorted, appLang, fromMulti: "tags", tempConfig });
            if (name === 'filesize' || name === "id" || name === "ID") {
                return changeStrAndSortNrOfObj({ convertedData, field: name, sorted })
            }
            if (name === "subtitle") {
                return sortMainContentFromMulti({ convertedData, appLang, mainfield: "subtitle", sorted, fromMulti: "tags", tempConfig });
            }
            sortParams = sorted ? "" : "-";
            sortParams = sortParams + name;
            sortedData = convertedData.sort(DataUtil.dynamicSortAndIgnoreCase(sortParams));
            return sortedData;
        }
        return [];
    } catch (error) {
        console.log("LAMTEST getMfSortedData");
        return data;
    }
}

/* TABLE SORTING END */


export const changeMetaDataForSorting = (data) => {
    let isChanged = false;
    let newData = [];
    data.map(item => {
        let found = MEDIA_FIELDS.find(obj => obj.media === item.media);
        if (found) {
            isChanged = true;
            newData.push({ ...item, media: found.changedMedia, custom_media_original: found.media });
        } else
            newData.push(item);
    })
    if (isChanged) return newData;

    return false;
}

export const setOriginalMetaDataForSorting = (data) => {
    let newData = [];
    data.map(item => {
        if (item.custom_media_original) {
            let found = MEDIA_FIELDS.find(obj => obj.media === item.custom_media_original);
            if (found) {
                delete item.custom_media_original;
                newData.push({ ...item, media: found.media });
            }
        }
        else
            newData.push(item);
    })
    return newData;
}

export const sortDataByChangedMediaType = (data, elementProperty) => {
    let newData = [];
    try {
        if (elementProperty === CustomTypes.SORT_MEDIA) {
            newData = changeMetaDataForSorting(data);
            if (newData.length > 0) {
                newData = data.sort(DataUtil.dynamicSortAndIgnoreCase(CustomTypes.SORT_MEDIA));
                newData = this.setOriginalMetaDataForSorting(newData);
                return newData;
            }

            return data.sort(DataUtil.dynamicSortAndIgnoreCase(elementProperty));
        }
    } catch (e) {
        return data.sort(DataUtil.dynamicSortAndIgnoreCase(elementProperty));
    }

}

export const getSortOptionForSearch = (params) => {
    try {
        if (params && params.customCurrentSortOption) {
            let field = DataUtil.subStringBefore(params.customCurrentSortOption, "|");
            let value = DataUtil.subStringAfter(params.customCurrentSortOption, "|");
            let sortOption = { field, type: 'ORDER', value };
            return sortOption;
        }

        return { field: DataUtil.getSortOptionsForApp('created'), type: 'ORDER', value: 'DESC' }
    } catch (error) {
        console.log("LAMTEST getSortOptionForSearch");
    }

    return params;
}

export const sortDataByChildElementProperty = ({ data, element, elementProperty, desc, type }) => {
    let clipIdKey = getClipKeyForApp();
    let newData = [];
    let sortedData = [];
    for (const item of data) {
        newData.push(item[element]);
    }
    if (isFrancetv() || isVifogra()) {
        if (isVifogra() && elementProperty.includes("title")) {
            let tmp = newData.sort(DataUtil.dynamicSortAndIgnoreCase(elementProperty));
            if (Array.isArray(tmp) && tmp.length > 0) newData = tmp;
        } else {
            if (desc === "DESC") newData = DataUtil.sortByProperty(newData, { prop: elementProperty, desc: true });
            else newData = DataUtil.sortByProperty(newData, { prop: elementProperty });
        }
    } else {
        let sortType = getSortTypeForData(elementProperty);
        if (type) sortType = type;
        if (sortType === CustomTypes.DATE) {
            if (desc === "DESC") newData = DataUtil.sortByProperty(newData, { prop: elementProperty, desc: true });
            else newData = DataUtil.sortByProperty(newData, { prop: elementProperty });
        } else if (sortType === CustomTypes.TEXT) {
            if (desc === "DESC") elementProperty = '-' + elementProperty;
            let tmp = newData.sort(DataUtil.dynamicSortAndIgnoreCase(elementProperty));
            if (Array.isArray(tmp) && tmp.length > 0) {
                newData = tmp;
            }
        }
    }
    for (const item of newData) {
        if (!item[clipIdKey]) {
            if (item[CustomTypes.ID]) clipIdKey = CustomTypes.ID;
            else clipIdKey = CustomTypes.CLIPID;
        }
        sortedData.push(DataUtil.findElementByProperty(data, "id", item[clipIdKey]));
    }
    return sortedData;
}

export const getSortTypeForData = (property) => {
    if (property.includes("date") || property === "created" || property === "rechte_produktionsdatum")
        return CustomTypes.DATE;
    else
        return CustomTypes.TEXT;
}

export const getSortOptionsForProjects = (data) => {
    let sortOption = {
        orderBy: "created",
        order: "DESC"
    }
    if (data && data !== "|") {
        sortOption.orderBy = DataUtil.subStringBefore(data, "|");
        sortOption.order = DataUtil.subStringAfter(data, "|");
    }
    return sortOption;
}

export const getClipKeyForApp = () => {
    if (isPMDB() || isNLW()) return CustomTypes.ID;
    else if (isANT()) return CustomTypes.CUTID;
    else return CustomTypes.CLIPID;
}

export const changeClipFieldForApp = (field, data) => {
    switch (field) {
        case CustomTypes.SORT_CREATED:
            return data.find(item => (CustomTypes.APP_CREATED_FIELDS.indexOf(item) !== -1));
        case CustomTypes.SORT_PRODATE:
            return data.find(item => (CustomTypes.APP_PROD_DATE_FIELDS.indexOf(item) !== -1))
        default:
            return field;
    }
}

export const getSortOptionsForApp = (sortOption, configClipInfo = []) => {
    try {
        if (!isPMDB()) {
            if (configClipInfo && configClipInfo.length > 0) {
                if (sortOption.includes(CustomTypes.SORT_CREATED)) {
                    if (isFcpworks() || isStandardGroup() || isFrancetv()) {
                        return sortOption.replace(CustomTypes.SORT_CREATED, "date2");
                    }
                    return sortOption.replace(CustomTypes.SORT_CREATED, changeClipFieldForApp(CustomTypes.SORT_CREATED, configClipInfo));
                } else if (sortOption.includes(CustomTypes.SORT_PRODATE)) {
                    if (isANT() || isStandardGroup() || isMotorvision() || isFrancetv() || isSynology()) {
                        return sortOption.replace(CustomTypes.SORT_PRODATE, "date1");
                    }
                    else if (isERTU()) {
                        return sortOption.replace(CustomTypes.SORT_PRODATE, "txt22");
                    }
                    return sortOption.replace(CustomTypes.SORT_PRODATE, changeClipFieldForApp(CustomTypes.SORT_PRODATE, configClipInfo));
                }
            }
            if (isFrancetv()) return sortOption.replace(CustomTypes.SORT_CREATED, "date2");
        }

    } catch (e) {
        console.log("LAMTEST getSortOptionsForApp");
    }

    return sortOption;
}

export const sortAdvanced = ({ a, b, sortFields, idx = 0 }) => {
    if (sortFields && sortFields.length > 0 && sortFields[idx]) {
        let item = sortFields[idx];
        if (item) {
            let order = item.o == 'DESC' ? -1 : 1;
            let aItem = a[item.p];
            let bItem = b[item.p];
            if (item.t == 'text') {
                if (aItem) aItem = aItem.toLowerCase();
                if (bItem) bItem = bItem.toLowerCase();
            }
            if (aItem && bItem) {
                if (aItem < bItem) return -1 * order;
                if (aItem > bItem) return 1 * order;
                if (aItem == bItem) {
                    idx++;
                    return sortAdvanced({ a, b, sortFields, idx })
                }
            }

            if (!aItem && bItem) return -1 * order;
            if (aItem && !bItem) return 1 * order;
        }
    }
    return 0;
}

export const sortMulti = ({ property, sortFields, type, sortOrder }) => {
    let sOrder = sortOrder == 'DESC' ? -1 : 1;
    return function (a, b) {
        let aEl = a[property];
        let bEl = b[property];
        if (type == 'text') {
            if (aEl) aEl = a[property].toLowerCase();
            if (bEl) bEl = b[property].toLowerCase();
        }
        if (aEl == bEl) return sortAdvanced({ a, b, sortFields });
        if (aEl < bEl) return -1 * sOrder;
        if (aEl > bEl) return 1 * sOrder;
    }
}

export const sortByMultiFields = ({ data, element, elementProperty, sortOrder, type, sortFields }) => {
    let clipIdKey = getClipKeyForApp();
    let newData = [];
    let sortedData = [];
    for (const item of data) {
        newData.push(item[element]);
    }
    let tmp = newData.sort(sortMulti({ property: elementProperty, sortFields, type, sortOrder }));
    if (Array.isArray(tmp) && tmp.length > 0) newData = tmp;
    for (const item of newData) {
        if (!item[clipIdKey]) {
            if (item[CustomTypes.ID]) clipIdKey = CustomTypes.ID;
            else clipIdKey = CustomTypes.CLIPID;
        }
        sortedData.push(DataUtil.findElementByProperty(data, "id", item[clipIdKey]));
    }
    return sortedData;
}

export const sortWithEmptyElements = ({ searchedClips, orderBy }) => {
    if (orderBy) {
        searchedClips = searchedClips.map((item, idx) => {
            if (item.metadata && item.metadata[orderBy]) item.customTempField = idx + 1;
            else item.customTempField = 9999999;
            return item;
        });
        searchedClips = SortHelper.sortByValue({
            data: searchedClips, sorted: "asc", field: "customTempField", isNumber: true
        })
        searchedClips = searchedClips.map(item => {
            delete item.customTempField;
            return item;
        });
    }
    return searchedClips;
}

export const sortClipsByMetadata = (clipList, clips, sortOpt, advanced = {}) => {
    let sortedClips = [];
    try {
        let searchedClips = DataUtil.getLongData(clipList, clips);
        if (isNLW()) searchedClips = searchedClips.filter(item => item ? item : null)
        let sortOption = DataUtil.getSortOptionsForApp(sortOpt);
        //  if ((sortOption === "id|DESC" && !search)) {
        if ((sortOption === CustomTypes.SORTING && !advanced.search)) {
            return searchedClips;
        } else {
            let sort = getSortOptionsForProjects(sortOption);
            let sortType = getSortTypeForData(sort.orderBy);
            if (isPorscheArchiv()) {
                let sortFields;
                if (advanced && advanced.sortFields) {
                    sortFields = advanced.sortFields;
                }
                searchedClips = sortWithEmptyElements({ searchedClips, orderBy: sort.orderBy });
                if (sortFields) console.log("LOGS: LAMTEST  sortFields", sortFields)
                sortedClips = sortByMultiFields({
                    data: searchedClips, element: "metadata",
                    elementProperty: sort.orderBy, sortOrder: sort.order,
                    type: sortType, sortFields
                });
            } else {
                sortedClips = sortDataByChildElementProperty({
                    data: searchedClips, element: "metadata", type: sortType,
                    elementProperty: sort.orderBy, desc: sort.order,
                });
            }
        }
    } catch (error) {
        console.log("LAMTEST sortClipsByMetadata");
    }
    return sortedClips;
}

